import useMinWidth from './useMinWidth'

export function useIsMinWidthXl() {
  return useMinWidth('xl')
}
